export default __webpack_public_path__ + "static/media/Virtual1-mobi.9b18b351.webp";